<script setup lang="ts">
import { computed } from 'vue'

interface EmptyBoxProps {
  icon: string
  text: string
}

const { icon, text } = defineProps<EmptyBoxProps>()

const classes = computed(() => [`n-i-${icon}`])
</script>
<template>
  <div class="st-empty-box-wrapper">
    <div class="st-empty-box-content">
      <div class="st-empty-box-icon">
        <i :class="classes" class="n-i nxgds-type-icon-40"></i>
      </div>
      <div class="st-empty-box-text-wrapper">
        <div class="nxgds-mapped-color-text-primary nxgds-type-h2-medium">
          {{ $t('common_not_available') }}
        </div>
        <div class="nxgds-mapped-color-text-secondary nxgds-type-paragraph-big-regular">
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.st-empty-box {
  &-wrapper {
    display: flex;
    padding: var(--nxgds-alias-spacing-lg);
    align-items: flex-start;
    gap: var(--nxgds-alias-spacing-lg);
    height: 100%;
  }

  &-content {
    display: flex;
    padding: var(--nxgds-alias-spacing-xl);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--nxgds-alias-spacing-2xl);
    flex: 1 0 0;
    align-self: stretch;
    border-radius: var(--nxgds-alias-radius-corner-theme);
    background: var(--nxgds-mapped-color-surface-component-card-default);
  }

  &-icon {
    display: flex;
    padding: var(--nxgds-alias-spacing-xl);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: var(--nxgds-alias-radius-corner-full);
    background: var(--nxgds-mapped-color-surface-component-subsection);

    i {
      color: var(--nxgds-mapped-color-icon-disabled);
      text-align: center;
    }
  }

  &-text-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--nxgds-alias-spacing-lg);
    flex-direction: column;
  }
}
</style>
